import React, { useState, useEffect } from "react";
import "../css/healthinsurance.css";
import "../css/consultationform.css";
import healthinsuranceimg from "../assets/healthinsuranceimg.webp";
import tollfreenumberimg from "../assets/tollfreenumberimg.webp";
import PoliciesSlider from "../components/PolicyiesSlider";
import ConsultationForm from "../components/ConsultationForm";
import ChatbotAi from "../components/ChatbotAi";
import axios from "axios";
import { Helmet } from 'react-helmet-async';

const HealthInsurance = () => {
  const API_URL = process.env.REACT_APP_Dashboard_API_URL;
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const imageSources = [
    healthinsuranceimg,
    tollfreenumberimg
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        (prevIndex + 1) % imageSources.length
      );
    }, 3000);
    return () => clearInterval(interval);
  }, [imageSources.length]);

  const handleSubmit = async (data) => {
    const inquriyData = new FormData();
    inquriyData.append("Name", data.Name);
    inquriyData.append("Email", data.Email);
    inquriyData.append("PreferredDate", data.Date);
    inquriyData.append("PreferredTime", data.Time);
    inquriyData.append("MobileNo", data.MobileNo);
    inquriyData.append("Status", "New");
    inquriyData.append("UserId", data.Id);
    inquriyData.append("InquiryType", "Insurance Inquiries");
    inquriyData.append("PolicyType", "Health Insurance");
    inquriyData.append("IsLoggedIn", data.isLoggedIn);
    inquriyData.append("Otp", data.OTP);

    try {
      const response = await axios.post(`${API_URL}AddNewInquiries`, inquriyData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return { status: response.status, data: response.data };
    } catch (error) {
      console.error("Error submitting consultation request:", error);
      return {
        status: 500,
        data: {
          success: false,
          message: error.response?.data?.message
        }
      };
    }
  };

  return (
    <div className="healthinsurance-container">
      <Helmet>
        <title>Health Insurance Guidance | Simplify Your Coverage Now</title>
        <meta
          name="description"
          content="Get expert health insurance guidance to pick plans that cover your needs. Clear, honest advice removes confusion for your peace of mind."
        />
        <meta
          name="keywords"
          content="health insurance guidance, health insurance consultation, insurance experts for personalized advice, best health insurance plan advice, compare insurance policies India"
        />
        <link rel="canonical" href="https://policysamjho.com/health-insurance-guidance/" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "Health Insurance Guidance",
            "description": "Expert guidance to choose the best health insurance plan for your needs. Understand benefits, compare policies, and get clear, unbiased advice from Policy Samjho.",
            "provider": {
              "@type": "Organization",
              "name": "Policy Samjho",
              "url": "https://policysamjho.com/"
            },
            "serviceType": "Health Insurance Consultation & Advice",
            "areaServed": "IN",
            "url": "https://policysamjho.com/health-insurance-guidance/",
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+91-9584484800",
              "email": "info@policysamjho.com",
              "contactType": "customer service"
            }
          })}
        </script>
      </Helmet>

      <div className="healthinsurance-hero-container">
        <div className="healthinsurance-hero-text-box">
          <h1>
            <span style={{ color: '#192437' }}>Health Insurance </span>
            <span style={{ color: '#F5A526' }}>Guidance</span>
          </h1>
          <p style={{ color: "black", fontWeight: "600", fontSize: "18px", textAlign: 'justify' }}>
            Protect yourself and your loved ones with a comprehensive health insurance
            plan designed to cover medical expenses, hospitalizations, and emergencies.
          </p>
        </div>

        <div className="healthinsurance-hero-image-box healthinsurance-imgslider">
          {imageSources.map((image, index) => (
            <img
              key={index}
              src={image}
              alt={`Health Insurance Visual ${index + 1}`}
              className="healthinsurance-sliderimg"
              style={{ display: index === currentImageIndex ? "block" : "none" }}
            />
          ))}
        </div>
      </div>

      <div className="healthinsurance-containform-container">
        <div className="col-md-6 healthinsurance-info">
          <h2 className="healthinsurance-heading">
            <span style={{ color: '#192437' }}>What is </span>
            <span style={{ color: '#F5A526' }}>Health Insurance?</span>
          </h2>
          <p className="healthinsurance-text">
            Health insurance provides financial protection by covering medical expenses
            due to illness, accidents, or hospitalization. It ensures access to quality
            healthcare without financial burdens.
          </p>

          <h2 className="healthinsurance-subheading">
            <span style={{ color: '#192437' }}>Why is Health </span>
            <span style={{ color: '#F5A526' }}>Insurance Important?</span>
          </h2>
          <ul className="healthinsurance-benefits">
            <li className="healthpoints">Access to quality healthcare</li>
            <li className="healthpoints">Emergency medical support</li>
            <li className="healthpoints">Covers hospitalization expenses</li>
            <li className="healthpoints">Financial protection from medical bills</li>
          </ul>

          <h2 className="healthinsurance-subheading">
            <span style={{ color: '#192437' }}>Comprehensive Coverage & </span>
            <span style={{ color: '#F5A526' }}>Health Benefits</span>
          </h2>
          <p className="healthinsurance-text spaced-text">
            Health insurance ensures financial security by covering a wide range of medical expenses,
            including hospitalization, doctor consultations, diagnostic tests, and surgical procedures.
            It provides access to quality healthcare without the burden of high medical costs. Policies
            often include coverage for preventive care, vaccinations, wellness checkups, and emergency medical support,
            ensuring timely treatment without financial stress. Additionally, many health insurance plans offer cashless
            hospitalization, maternity benefits, critical illness coverage, and alternative treatments like Ayurveda
            and Homeopathy.
          </p>
        </div>

        <div>
          <h4 className="consultationform-heading">
            <span style={{ color: "#192437" }}>Get a Free </span>
            <span style={{ color: "#F5A526" }}>Health Insurance Consultation</span>
          </h4>
          <ConsultationForm onSubmit={handleSubmit} />
        </div>
      </div>

      <PoliciesSlider category="Health Insurance" />
      <ChatbotAi />
    </div>
  );
};

export default HealthInsurance;
